'use client';

import React from 'react';
import { ApolloLink, HttpLink } from '@apollo/client';
import {
  ApolloNextAppProvider,
  InMemoryCache,
  ApolloClient,
  SSRMultipartLink,
} from '@apollo/client-integration-nextjs';
import { LOMA_URL_CLIENT } from '../../../constants/env';

export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );

  function makeClient() {
    const httpLink = new HttpLink({
      uri: LOMA_URL_CLIENT,
      fetchOptions: { cache: 'no-store' },
    });

    const link =
      typeof window === 'undefined'
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: false,
            }),
            httpLink,
          ])
        : ApolloLink.from([httpLink]);

    return new ApolloClient({
      cache: new InMemoryCache(),
      link,
    });
  }
}
